import CryptoJS from "crypto-js";

function deepSort(obj) {
  if (Array.isArray(obj)) {
    return obj.map(item => deepSort(item));
  }

  if (obj !== null && typeof obj === "object") {
    return Object.keys(obj)
      .sort()
      .reduce((acc, key) => {
        acc[key] = deepSort(obj[key]);
        return acc;
      }, {});
  }

  return obj;
}


export default function generateHmacSignature(payload) {
  const secretKey = "3f9d67c4e12a4879a1b5cf0e8d3a2f9d";

  const sortedPayload = deepSort(payload);
  const payloadString = JSON.stringify(sortedPayload);

  const signature = CryptoJS.HmacSHA256(payloadString, secretKey)
    .toString(CryptoJS.enc.Base64);

  return {
    data: sortedPayload,
    signature
  };
}
